import {match} from 'ts-pattern';

import {AvailabilityCheckStatus} from '../types';

export function isTerminalAvailabilityStatus(
  status: AvailabilityCheckStatus | undefined
): status is 'active' | 'just_sold' | 'unsupported_platform' {
  return match(status)
    .with('active', 'just_sold', 'unsupported_platform', () => true)
    .otherwise(() => false);
}
